import React, { useEffect, useState } from "react";
import { announcements } from "@/config/brand";

export function AnnouncementBar() {
  const [i, setI] = useState(0);
  useEffect(() => {
    const t = setInterval(() => setI((p) => (p + 1) % announcements.length), 4000);
    return () => clearInterval(t);
  }, []);
  return (
    <div className="bg-ink text-ivory" data-testid="announcement-bar">
      <div className="mx-auto flex h-9 max-w-7xl items-center justify-center overflow-hidden px-4">
        <p key={i} className="animate-fade-in text-center text-[11px] font-medium uppercase tracking-[0.2em]">
          {announcements[i]}
        </p>
      </div>
    </div>
  );
}
